export default __webpack_public_path__ + "static/media/NFT3.b2bb7021.png";